<!--
 * @Author: zql
 * @Date: 2020-03-13 15:29:14
 * @LastEditTime: 2020-06-02 14:34:27
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \enfry-components\packages\components\en-result\src\noRecord\no-record.vue
-->
<template>
  <div ref="NoRecord" class="norecord">
    <img
      slot="icon"
      class="icon-img"
      src="http://cdn.enfry.com/no-record11323.png"
      :alt="this.title"
    />
    <div class="title" v-html="title"></div>
    <div class="subtitle" v-html="subTitle"></div>
  </div>
</template>

<script>
export default {
  name: "NoRecord",
  props: {
    type: { type: String, default: null },
    icon: {
      type: String,
      default: null
    },
    iconSize: {
      type: [String, Number],
      default: "normal"
    },
    title: {
      type: String,
      default: null
    },
    subTitle: {
      type: String,
      default: "暂无记录"
    }
  }
};
</script>
<style lang="scss" scoped>
.norecord {
  text-align: center;
  .icon-img {
    height: 80px;
    width: 120px;
  }
}
</style>
